import React, { useEffect } from 'react';
import $ from 'jquery';
// import './../assets/js/jquery.magnific-popup.min.js'
// window.jQuery = $;
// window.$ = $;
// // require('assets/jquery.magnific-popup.min.js');
const ImageGallery = () => {
    useEffect(() => {
    if ($.fn.magnificPopup) {
      $('.gallery-items').magnificPopup({
        delegate: 'a',
        type: 'image',
        closeOnContentClick: false,
        closeBtnInside: false,
        mainClass: 'mfp-with-zoom',
        image: { verticalFit: true },
        gallery: { enabled: true },
        zoom: {
          enabled: true,
          duration: 300,
          opener: function (element) {
            return element.find('img');
          },
        },
      });
    } else {
      console.warn('magnificPopup not available on $.fn');
    }
  }, []);
    return (
        <>
            {/* Photo Gallery Section Start */}
            <div className="page-gallery">
                <div className="container">
                    {/* gallery section start */}
                    <div className="row gallery-items page-gallery-box">
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div className="photo-gallery wow fadeInUp" data-cursor-text="View">
                                <a href="images/gallery-1.jpg">
                                    <figure className="image-anime">
                                        <img src="images/gallery-1.jpg" alt="" />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div
                                className="photo-gallery wow fadeInUp"
                                data-wow-delay="0.2s"
                                data-cursor-text="View"
                            >
                                <a href="images/gallery-2.jpg">
                                    <figure className="image-anime">
                                        <img src="images/gallery-2.jpg" alt="" />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div
                                className="photo-gallery wow fadeInUp"
                                data-wow-delay="0.4s"
                                data-cursor-text="View"
                            >
                                <a href="images/gallery-3.jpg">
                                    <figure className="image-anime">
                                        <img src="images/gallery-3.jpg" alt="" />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div
                                className="photo-gallery wow fadeInUp"
                                data-wow-delay="0.6s"
                                data-cursor-text="View"
                            >
                                <a href="images/gallery-4.jpg">
                                    <figure className="image-anime">
                                        <img src="images/gallery-4.jpg" alt="" />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div
                                className="photo-gallery wow fadeInUp"
                                data-wow-delay="0.8s"
                                data-cursor-text="View"
                            >
                                <a href="images/gallery-5.jpg">
                                    <figure className="image-anime">
                                        <img src="images/gallery-5.jpg" alt="" />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div
                                className="photo-gallery wow fadeInUp"
                                data-wow-delay="1s"
                                data-cursor-text="View"
                            >
                                <a href="images/gallery-6.jpg">
                                    <figure className="image-anime">
                                        <img src="images/gallery-6.jpg" alt="" />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div
                                className="photo-gallery wow fadeInUp"
                                data-wow-delay="1.2s"
                                data-cursor-text="View"
                            >
                                <a href="images/gallery-7.jpg">
                                    <figure className="image-anime">
                                        <img src="images/gallery-7.jpg" alt="" />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div
                                className="photo-gallery wow fadeInUp"
                                data-wow-delay="1.4s"
                                data-cursor-text="View"
                            >
                                <a href="images/gallery-8.jpg">
                                    <figure className="image-anime">
                                        <img src="images/gallery-8.jpg" alt="" />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                        <div className="col-lg-4 col-6">
                            {/* image gallery start */}
                            <div
                                className="photo-gallery wow fadeInUp"
                                data-wow-delay="1.6s"
                                data-cursor-text="View"
                            >
                                <a href="images/gallery-9.jpg">
                                    <figure className="image-anime">
                                        <img src="images/gallery-9.jpg" alt="" />
                                    </figure>
                                </a>
                            </div>
                            {/* image gallery end */}
                        </div>
                    </div>
                    {/* gallery section end */}
                </div>
            </div>
            {/* Photo Gallery Section End */}
        </>

    )
}

export default ImageGallery
